import React, { useState } from "react";
import { CloseIcon } from "./Icons";

const AssetMapModal = ({ controller, assets = [], onAssignAsset, onClose, isSaving }) => {
  const [selAssets, setSelAssets] = useState(controller.asset_ids || []);
  const safeAssets = Array.isArray(assets) ? assets : assets?.data || [];

  const toggleAsset = (id) =>
    setSelAssets((prev) =>
      prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id],
    );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gray-50">
          <div>
            <h3 className="text-base font-bold text-gray-800">Assign Assets</h3>
            <p className="text-xs text-gray-500 mt-0.5">{controller.name}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <CloseIcon />
          </button>
        </div>

        <div className="p-4 max-h-60 overflow-y-auto">
          {safeAssets.length === 0 ? (
            <p className="text-center text-sm text-gray-400 py-6">No assets found.</p>
          ) : (
            <div className="space-y-1">
              {safeAssets.map((asset) => {
                const isSelected = selAssets.includes(asset.id);
                return (
                  <button
                    key={asset.id}
                    onClick={() => toggleAsset(asset.id)}
                    className={`w-full text-left py-2.5 px-3 rounded-lg text-sm transition-colors flex items-center gap-3 ${
                      isSelected
                        ? "bg-purple-50 text-purple-800 font-medium border border-purple-200"
                        : "hover:bg-gray-50 text-gray-700"
                    }`}
                  >
                    <div
                      className={`w-4 h-4 rounded border flex items-center justify-center flex-shrink-0 ${
                        isSelected ? "bg-purple-600 border-purple-600" : "border-gray-300"
                      }`}
                    >
                      {isSelected && (
                        <svg
                          className="w-3 h-3 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={3}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      )}
                    </div>
                    <span className="flex-1">{asset.name}</span>
                    {asset.asset_type && (
                      <span className="text-[10px] text-gray-400">{asset.asset_type}</span>
                    )}
                  </button>
                );
              })}
            </div>
          )}
        </div>

        <div className="flex gap-3 p-4 border-t border-gray-100">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-sm border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
          >
            Cancel
          </button>
          <button
            disabled={isSaving}
            onClick={() => onAssignAsset(selAssets)}
            className="flex-1 px-4 py-2 text-sm bg-purple-700 text-white rounded-lg hover:bg-purple-800 font-medium disabled:opacity-40"
          >
            {isSaving ? "Saving…" : "Assign Assets"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssetMapModal;
